/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FastCashContainer_fastCash$ref = any;
export type CheckAndUpdateStatusInput = {|
  clientMutationId?: ?string,
  integrationItemId: string,
|};
export type checkAndUpdateStatusMutationVariables = {|
  input: CheckAndUpdateStatusInput,
  byAuth0Id: string,
  afterDate: any,
  beforeDate: any,
  bankAccountIdEq: string,
  stateEq?: ?string,
  storeIdEq?: ?string,
  integrationItemIdEq?: ?number,
  nameCont?: ?string,
  byMerchantNames?: ?string,
  nameNotIContAll?: ?string,
|};
export type checkAndUpdateStatusMutationResponse = {|
  +checkAndUpdateStatus: ?{|
    +errorMessage: ?string,
    +successMessage: ?string,
    +fastCash: ?{|
      +$fragmentRefs: FastCashContainer_fastCash$ref
    |},
  |}
|};
export type checkAndUpdateStatusMutation = {|
  variables: checkAndUpdateStatusMutationVariables,
  response: checkAndUpdateStatusMutationResponse,
|};
*/


/*
mutation checkAndUpdateStatusMutation(
  $input: CheckAndUpdateStatusInput!
  $byAuth0Id: String!
  $afterDate: Date!
  $beforeDate: Date!
  $bankAccountIdEq: String!
  $stateEq: String
  $storeIdEq: String
  $integrationItemIdEq: Int
  $nameCont: String
  $byMerchantNames: String
  $nameNotIContAll: String
) {
  checkAndUpdateStatus(input: $input) {
    errorMessage
    successMessage
    fastCash(byAuth0Id: $byAuth0Id) {
      ...FastCashContainer_fastCash
      id
    }
  }
}

fragment BankAccountCell_bankAccount on BankAccount {
  id
  plaidAccountId
  mask
  name
  officialName
  accountSubtype
  accountType
  originalBankAccount {
    id
    ownerAuth0Id
    plaidAccountId
  }
  duplicationState
  availableDuplicationStates
  bankAccountsWithMask {
    id
  }
  integrationItem {
    institutionName
    id
  }
}

fragment CashbackCell_cashback on Cashback {
  id
  date
  name
  rate
  place
  storeId
  amount
  source
  plaidTransactionId
  transactionAmount
  state
  quarantinedReason
  availableStates
}

fragment FastCashContainer_fastCash on FastCash {
  id
  lifetimeCash
  availableCash
  pendingCash
  specialCashbackRate {
    id
    fastCashId
    userId
    comment
    state
    cashbackRate
    createdAt
    updatedAt
    deletedAt
  }
  firstOnboardedAt
  blockedState
  transactionsData(afterDate: $afterDate, beforeDate: $beforeDate, stateEq: $stateEq, bankAccountIdEq: $bankAccountIdEq, storeIdEq: $storeIdEq, integrationItemIdEq: $integrationItemIdEq, nameCont: $nameCont, byMerchantNames: $byMerchantNames, nameNotIContAll: $nameNotIContAll) {
    transactionsCount
    depositsAmount
    expensesAmount
  }
  cashbacksData(afterDate: $afterDate, beforeDate: $beforeDate) {
    netCashbacksAmount
    spentCashbacksAmount
    earnedCashbacksAmount
    refundCashbacksAmount
  }
  integrationItems {
    id
    institutionName
    itemId
    state
    errorCode
    accountOnboardedAt
  }
  user {
    email
    referrer {
      fullName
      auth0Id
      id
    }
    invitedUsers {
      auth0Id
      fullName
      id
    }
    id
  }
  cashbacks(afterDate: $afterDate, beforeDate: $beforeDate) {
    id
    name
    amount
    state
    date
    quarantinedReason
    availableStates
    storeId
    place
    ...CashbackCell_cashback
  }
  bankAccounts {
    id
    name
    duplicationState
    plaidAccountId
    availableDuplicationStates
    bankAccountsWithMask {
      id
    }
    integrationItem {
      institutionName
      id
    }
    ...BankAccountCell_bankAccount
  }
  checkIns(afterDate: $afterDate, beforeDate: $beforeDate) {
    id
    createdAt
  }
  latestMembershipState
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CheckAndUpdateStatusInput!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "byAuth0Id",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDate",
    "type": "Date!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "beforeDate",
    "type": "Date!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bankAccountIdEq",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stateEq",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeIdEq",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "integrationItemIdEq",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nameCont",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "byMerchantNames",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nameNotIContAll",
    "type": "String"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "successMessage",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "byAuth0Id",
    "variableName": "byAuth0Id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "kind": "Variable",
  "name": "afterDate",
  "variableName": "afterDate"
},
v9 = {
  "kind": "Variable",
  "name": "beforeDate",
  "variableName": "beforeDate"
},
v10 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "institutionName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "auth0Id",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plaidAccountId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "checkAndUpdateStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CheckAndUpdateStatusPayload",
        "kind": "LinkedField",
        "name": "checkAndUpdateStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "FastCash",
            "kind": "LinkedField",
            "name": "fastCash",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FastCashContainer_fastCash"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "checkAndUpdateStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CheckAndUpdateStatusPayload",
        "kind": "LinkedField",
        "name": "checkAndUpdateStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "FastCash",
            "kind": "LinkedField",
            "name": "fastCash",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lifetimeCash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableCash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pendingCash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SpecialCashback",
                "kind": "LinkedField",
                "name": "specialCashbackRate",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fastCashId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "comment",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cashbackRate",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstOnboardedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "blockedState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "bankAccountIdEq",
                    "variableName": "bankAccountIdEq"
                  },
                  (v9/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "byMerchantNames",
                    "variableName": "byMerchantNames"
                  },
                  {
                    "kind": "Variable",
                    "name": "integrationItemIdEq",
                    "variableName": "integrationItemIdEq"
                  },
                  {
                    "kind": "Variable",
                    "name": "nameCont",
                    "variableName": "nameCont"
                  },
                  {
                    "kind": "Variable",
                    "name": "nameNotIContAll",
                    "variableName": "nameNotIContAll"
                  },
                  {
                    "kind": "Variable",
                    "name": "stateEq",
                    "variableName": "stateEq"
                  },
                  {
                    "kind": "Variable",
                    "name": "storeIdEq",
                    "variableName": "storeIdEq"
                  }
                ],
                "concreteType": "TransactionsData",
                "kind": "LinkedField",
                "name": "transactionsData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transactionsCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "depositsAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expensesAmount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "CashbacksData",
                "kind": "LinkedField",
                "name": "cashbacksData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "netCashbacksAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spentCashbacksAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "earnedCashbacksAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refundCashbacksAmount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationItem",
                "kind": "LinkedField",
                "name": "integrationItems",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "itemId",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "errorCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountOnboardedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "referrer",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "invitedUsers",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v12/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "Cashback",
                "kind": "LinkedField",
                "name": "cashbacks",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amount",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "quarantinedReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "availableStates",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "place",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "source",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plaidTransactionId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transactionAmount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BankAccount",
                "kind": "LinkedField",
                "name": "bankAccounts",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duplicationState",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "availableDuplicationStates",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BankAccount",
                    "kind": "LinkedField",
                    "name": "bankAccountsWithMask",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationItem",
                    "kind": "LinkedField",
                    "name": "integrationItem",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mask",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "officialName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountSubtype",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BankAccount",
                    "kind": "LinkedField",
                    "name": "originalBankAccount",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ownerAuth0Id",
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "CheckIn",
                "kind": "LinkedField",
                "name": "checkIns",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latestMembershipState",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "checkAndUpdateStatusMutation",
    "operationKind": "mutation",
    "text": "mutation checkAndUpdateStatusMutation(\n  $input: CheckAndUpdateStatusInput!\n  $byAuth0Id: String!\n  $afterDate: Date!\n  $beforeDate: Date!\n  $bankAccountIdEq: String!\n  $stateEq: String\n  $storeIdEq: String\n  $integrationItemIdEq: Int\n  $nameCont: String\n  $byMerchantNames: String\n  $nameNotIContAll: String\n) {\n  checkAndUpdateStatus(input: $input) {\n    errorMessage\n    successMessage\n    fastCash(byAuth0Id: $byAuth0Id) {\n      ...FastCashContainer_fastCash\n      id\n    }\n  }\n}\n\nfragment BankAccountCell_bankAccount on BankAccount {\n  id\n  plaidAccountId\n  mask\n  name\n  officialName\n  accountSubtype\n  accountType\n  originalBankAccount {\n    id\n    ownerAuth0Id\n    plaidAccountId\n  }\n  duplicationState\n  availableDuplicationStates\n  bankAccountsWithMask {\n    id\n  }\n  integrationItem {\n    institutionName\n    id\n  }\n}\n\nfragment CashbackCell_cashback on Cashback {\n  id\n  date\n  name\n  rate\n  place\n  storeId\n  amount\n  source\n  plaidTransactionId\n  transactionAmount\n  state\n  quarantinedReason\n  availableStates\n}\n\nfragment FastCashContainer_fastCash on FastCash {\n  id\n  lifetimeCash\n  availableCash\n  pendingCash\n  specialCashbackRate {\n    id\n    fastCashId\n    userId\n    comment\n    state\n    cashbackRate\n    createdAt\n    updatedAt\n    deletedAt\n  }\n  firstOnboardedAt\n  blockedState\n  transactionsData(afterDate: $afterDate, beforeDate: $beforeDate, stateEq: $stateEq, bankAccountIdEq: $bankAccountIdEq, storeIdEq: $storeIdEq, integrationItemIdEq: $integrationItemIdEq, nameCont: $nameCont, byMerchantNames: $byMerchantNames, nameNotIContAll: $nameNotIContAll) {\n    transactionsCount\n    depositsAmount\n    expensesAmount\n  }\n  cashbacksData(afterDate: $afterDate, beforeDate: $beforeDate) {\n    netCashbacksAmount\n    spentCashbacksAmount\n    earnedCashbacksAmount\n    refundCashbacksAmount\n  }\n  integrationItems {\n    id\n    institutionName\n    itemId\n    state\n    errorCode\n    accountOnboardedAt\n  }\n  user {\n    email\n    referrer {\n      fullName\n      auth0Id\n      id\n    }\n    invitedUsers {\n      auth0Id\n      fullName\n      id\n    }\n    id\n  }\n  cashbacks(afterDate: $afterDate, beforeDate: $beforeDate) {\n    id\n    name\n    amount\n    state\n    date\n    quarantinedReason\n    availableStates\n    storeId\n    place\n    ...CashbackCell_cashback\n  }\n  bankAccounts {\n    id\n    name\n    duplicationState\n    plaidAccountId\n    availableDuplicationStates\n    bankAccountsWithMask {\n      id\n    }\n    integrationItem {\n      institutionName\n      id\n    }\n    ...BankAccountCell_bankAccount\n  }\n  checkIns(afterDate: $afterDate, beforeDate: $beforeDate) {\n    id\n    createdAt\n  }\n  latestMembershipState\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3e05c00a4e8c57d242a28222acd9a637';

module.exports = node;
